<template>
    <div class="DocumentActionSplitLayout">
        <q-splitter
            ref="splitter"
            v-model="splitterPosition"
            separator-class="bg-transparent"
            :limits="[30, 70]"
            :separator-style="{ width: '40px' }"
        >
            <template #before>
                <slot name="before" />
            </template>

            <template #separator>
                <div class="DocumentActionSplitLayout__separator">
                    <EidIcon :icon-src="resizeIcon" />
                </div>
                <div class="h-full w-[2px] bg-eidSecureBlue-10" />
            </template>

            <template #after>
                <div class="DocumentActionSplitLayout__right" :style="{ minHeight: rightPanelMinHeight }">
                    <slot name="after" />
                </div>
            </template>
        </q-splitter>
    </div>
</template>

<style lang="scss">
.DocumentActionSplitLayout {
    padding: 21px;

    &__separator {
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        height: 17px;
        width: 12px;
        background: color-mix(in sRGB, var(--eidSecureBlue-10) 30%, transparent);
        border: 1px solid var(--eidSecureBlue-10);

        svg {
            width: 7px;
            height: 7px;
        }
    }

    &__right {
        height: 100%;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { QSplitter } from 'quasar';

    import { faGripVertical } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    const DEFAULT_SPLITTER_POSITION = 60;

    export default defineComponent({
        name: 'DocumentActionSplitLayout',
        components: {
            EidIcon,
            QSplitter,
        },
        props: {
            splitterStorageKey: {
                type: String as PropType<string>,
                default: '',
            },
            rightPanelMinHeight: {
                type: String as PropType<string>,
                default: 'auto',
            },
        },
        data() {
            const splitterStorageKey = (this as any).splitterStorageKey;
            const savedPosition = splitterStorageKey ? localStorage.getItem(splitterStorageKey) : null;
            const initialPosition = savedPosition ? parseInt(savedPosition, 10) : DEFAULT_SPLITTER_POSITION;

            return {
                resizeIcon: faGripVertical,
                splitterPosition: initialPosition,
            };
        },
        watch: {
            splitterPosition: {
                handler(newPosition: number) {
                    if ((this as any).splitterStorageKey) {
                        localStorage.setItem((this as any).splitterStorageKey, newPosition.toString());
                    }
                },
                immediate: false,
            },
        },
    });
</script>
